import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

import "react-toastify/dist/ReactToastify.min.css";
import "./index.css";

import App from "./App";

// Disable React DevTools in production
disableReactDevTools();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Report statistics around web vitals (optional)
reportWebVitals();
